<template>
  <div class="col-12">
    <div class="col-sm-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4">
      <el-card>
        <div slot="header" class="clearfix">
          <h3>Email verification</h3>
        </div>
        <div class="d-flex justify-content-center" v-if="loading">
          <div class="loader w-100"></div>
        </div>
        <div v-else-if="error">
          <el-alert
            title="Error"
            :description="errorMessage"
            type="error"
            :closable="false"
            :show-icon="true"
          >
          </el-alert>
        </div>
        <div v-else-if="success">
          <el-alert
            title="Success"
            :description="successMessage"
            type="success"
            :closable="false"
            :show-icon="true"
          >
          </el-alert>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userId: this.$route.query.id,
      token: this.$route.query.token,
      loading: true,
      success: false,
      successMessage: null,
      error: false,
      errorMessage: null,
    };
  },
  methods: {
    verifyUser() {
      let vm = this;
      vm.loading = true;
      vm.error = false;
      vm.errorMessage = null;
      vm.$http
        .post("user/verify", {
          user_id: vm.userId,
          token: vm.token,
        })
        .then(
          (response) => {
            // success
            vm.error = false;
            vm.loading = false;
            vm.success = true;
            vm.successMessage = response.body.message;
          },
          (response) => {
            vm.success = false;
            vm.loading = false;
            vm.error = true;
            vm.errorMessage = response.body.non_field_errors[0];
          }
        );
    },
  },
  created() {
    let vm = this;
    if (!this.userId || !this.token) {
      vm.error = true;
      vm.errorMessage = "The link you followed isn't working.";
      vm.loading = false;
    } else {
      this.verifyUser();
    }
  },
};
</script>
<style lang="scss">
.loader {
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
